import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
    state: {
        loginState: false,
        userType: 0,
        userInfo: {}
    },
    mutations: {
        loginMutation(state, info) {
            state.loginState = true;
            state.userType = info.userType;
            state.userInfo = info.userInfo;

            sessionStorage.setItem("userType", info.userType);
            sessionStorage.setItem("userInfo", JSON.stringify(info.userInfo));
        },
        signOutMutation(state) {
            state.loginState = false;
            state.userType = 0;
            state.userInfo = {};

            sessionStorage.removeItem("userType");
            sessionStorage.removeItem("userInfo");
        }
    },
    actions: {
        loginAction(context, info) {
            context.commit('loginMutation', info);
        },
        signOutAction(context) {
            context.commit('signOutMutation');
        }
    }
})
